// The order of loading this CSS is important. It must come FIRST because it has a lot of base styles,
// which our application CSS will override.
import "@mantine/core/styles.css";
import '@mantine/dates/styles.css';
import DashboardApi from "@/packages/api/DashboardApi";
import { Home } from "@/packages/dashboard/Home/Home";
import { LogMeals } from "@/packages/dashboard/Home/LogMeals/log-meals";
import { LogMealsNewFoodRoute } from "@/packages/dashboard/Home/LogMeals/new-food-item-route";
import { Targets } from "@/packages/dashboard/Home/Targets/Targets";
import { FoodItems } from "@/packages/dashboard/Home/FoodItems/FoodItems";
import { JaloriesAppShell } from "@/packages/dashboard/layouts/JaloriesAppShell";

import { createTheme, MantineColorsTuple, MantineProvider } from "@mantine/core";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { dashboardQueryClient } from "@/packages/dashboard/query-client";
import { UserTargetsProvider } from "@/packages/dashboard/UserTargets/UserTargetsProvider";

type DashboardAppProps = { sseServerUrl: string };

const tomato: MantineColorsTuple = [
  "#fff0e4",
  "#ffe0cf",
  "#fac0a1",
  "#f69e6e",
  "#f28043",
  "#f06e27",
  "#f06418",
  "#d6530c",
  "#bf4906",
  "#a73c00",
];

const deepOrange: MantineColorsTuple = [
  "#fff4e1",
  "#ffe8cc",
  "#fed09b",
  "#fdb766",
  "#fca13a",
  "#fc931d",
  "#fc8a08",
  "#e17800",
  "#c86a00",
  "#af5a00"
]

const myMantineTheme = createTheme({
  colors: {
    tomato,
    deepOrange
  },
  shadows: {
    md: "1px 1px 3px rgba(0, 0, 0, .25)",
    xl: "5px 5px 3px rgba(0, 0, 0, .25)",
  },

  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
});

function App(inputProps: DashboardAppProps) {
  //const { sseServerUrl } = inputProps;
  const props = {};

  const baseRouteForSpa = DashboardApi.show.path({});
  return (
    <>
      <BrowserRouter basename={baseRouteForSpa}>
        <UserTargetsProvider>
          <JaloriesAppShell>
            <Routes>
              <Route path="/" element={<Home {...props} />} />
              <Route path="/add-meals" element={<LogMeals {...props} />}>
                <Route path="new-food" element={<LogMealsNewFoodRoute />} />
              </Route>
              <Route path="/add-meals/:mealId" element={<LogMeals {...props} />}>
                <Route path="new-food" element={<LogMealsNewFoodRoute />} />
              </Route>
              <Route path="/food-items" element={<FoodItems {...props} />} />
              <Route path="/targets" element={<Targets {...props} />} />
            </Routes>
          </JaloriesAppShell>
        </UserTargetsProvider>
      </BrowserRouter>
    </>
  );
}

export default function Dashboard(dashboardAppProps: DashboardAppProps) {
  return (
    <QueryClientProvider client={dashboardQueryClient}>
      <MantineProvider theme={myMantineTheme}>
        <App {...dashboardAppProps} />
      </MantineProvider>
    </QueryClientProvider>
  );
}
